import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const CsvFileImage = (t0)=>{
    const $ = c(9);
    const { width, height } = t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4064 5H35.5L48.9999 18.8V45.0115C48.9999 48.3218 46.1974 50.9999 42.7453 50.9999H19.2666C15.8025 50.9999 13 48.3218 13 45.0115V10.9884C12.9999 7.6781 15.9423 5 19.4064 5Z",
            fill: "#E2E6EB"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M35.5289 14.384V5L48.9999 18.8L40.0192 18.8C35.9779 18.8 35.3418 15.856 35.5289 14.384Z",
            fill: "#BAC6D1"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M7 33C7 30.7909 8.79086 29 11 29H38C40.2091 29 42 30.7909 42 33V43C42 45.2091 40.2091 47 38 47H11C8.79086 47 7 45.2091 7 43V33Z",
            fill: "#3F8904"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M31.1448 33.2706L33.43 40.4538H33.5177L35.8075 33.2706H38.0234L34.7642 42.7251H32.1882L28.9243 33.2706H31.1448Z",
            fill: "white"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M26.0471 35.9897C26.0102 35.6173 25.8517 35.328 25.5716 35.1218C25.2915 34.9156 24.9114 34.8125 24.4313 34.8125C24.1051 34.8125 23.8296 34.8587 23.605 34.951C23.3803 35.0402 23.208 35.1649 23.0879 35.3249C22.971 35.485 22.9125 35.6665 22.9125 35.8697C22.9064 36.0389 22.9417 36.1867 23.0187 36.3129C23.0987 36.439 23.208 36.5483 23.3465 36.6406C23.485 36.7299 23.645 36.8084 23.8266 36.8761C24.0082 36.9407 24.202 36.9961 24.4082 37.0423L25.2577 37.2454C25.6701 37.3377 26.0486 37.4608 26.3933 37.6147C26.738 37.7686 27.0366 37.9579 27.2889 38.1825C27.5413 38.4072 27.7367 38.6719 27.8752 38.9766C28.0168 39.2812 28.0891 39.6306 28.0922 40.0245C28.0891 40.6031 27.9414 41.1048 27.649 41.5295C27.3597 41.9511 26.9412 42.2789 26.3933 42.5128C25.8486 42.7436 25.1915 42.859 24.4221 42.859C23.6588 42.859 22.9941 42.7421 22.4278 42.5082C21.8646 42.2743 21.4245 41.928 21.1075 41.4695C20.7935 41.0078 20.6289 40.4369 20.6135 39.7567H22.5478C22.5694 40.0737 22.6601 40.3384 22.8202 40.5508C22.9833 40.7601 23.2003 40.9186 23.4711 41.0263C23.745 41.1309 24.0543 41.1832 24.399 41.1832C24.7376 41.1832 25.0315 41.134 25.2808 41.0355C25.5331 40.937 25.7286 40.8001 25.8671 40.6246C26.0055 40.4492 26.0748 40.2476 26.0748 40.0199C26.0748 39.8075 26.0117 39.629 25.8855 39.4844C25.7624 39.3397 25.5808 39.2166 25.3408 39.1151C25.1038 39.0135 24.813 38.9212 24.4683 38.8381L23.4388 38.5795C22.6417 38.3857 22.0123 38.0825 21.5506 37.6701C21.089 37.2577 20.8597 36.7022 20.8628 36.0036C20.8597 35.4311 21.0121 34.931 21.3198 34.5032C21.6307 34.0754 22.0569 33.7415 22.5986 33.5014C23.1403 33.2614 23.7558 33.1413 24.4452 33.1413C25.1469 33.1413 25.7593 33.2614 26.2825 33.5014C26.8088 33.7415 27.2181 34.0754 27.5105 34.5032C27.8029 34.931 27.9537 35.4265 27.9629 35.9897H26.0471Z",
            fill: "white"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M19.4848 36.5806H17.4628C17.4258 36.319 17.3504 36.0866 17.2366 35.8835C17.1227 35.6773 16.9765 35.5019 16.798 35.3572C16.6195 35.2126 16.4133 35.1018 16.1794 35.0249C15.9486 34.9479 15.6977 34.9094 15.4269 34.9094C14.9375 34.9094 14.5113 35.031 14.1481 35.2741C13.785 35.5142 13.5034 35.8651 13.3033 36.3267C13.1033 36.7853 13.0032 37.3423 13.0032 37.9979C13.0032 38.6719 13.1033 39.2382 13.3033 39.6967C13.5064 40.1553 13.7896 40.5015 14.1527 40.7354C14.5159 40.9693 14.936 41.0863 15.413 41.0863C15.6808 41.0863 15.9285 41.0509 16.1563 40.9801C16.3871 40.9093 16.5918 40.8062 16.7703 40.6708C16.9488 40.5323 17.0965 40.3646 17.2135 40.1676C17.3335 39.9706 17.4166 39.746 17.4628 39.4936L19.4848 39.5028C19.4325 39.9368 19.3017 40.3554 19.0924 40.7585C18.8862 41.1586 18.6076 41.5172 18.2568 41.8342C17.909 42.1481 17.4935 42.3974 17.0103 42.582C16.5302 42.7636 15.987 42.8544 15.3807 42.8544C14.5374 42.8544 13.7834 42.6636 13.1187 42.282C12.457 41.9003 11.9338 41.3479 11.549 40.6246C11.1674 39.9014 10.9766 39.0258 10.9766 37.9979C10.9766 36.9669 11.1705 36.0897 11.5583 35.3665C11.9461 34.6432 12.4723 34.0923 13.1371 33.7138C13.8019 33.3321 14.5498 33.1413 15.3807 33.1413C15.9285 33.1413 16.4364 33.2183 16.9042 33.3722C17.375 33.526 17.7921 33.7507 18.1552 34.0462C18.5184 34.3385 18.8138 34.6971 19.0416 35.1218C19.2724 35.5465 19.4201 36.0328 19.4848 36.5806Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== height || $[7] !== width) {
        t7 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6
            ]
        });
        $[6] = height;
        $[7] = width;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
};
export { CsvFileImage };
